import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { GiphyBlockAttsInterface } from '~/types/AppData/Blocks/GiphyBlockInterface';

export default component$((value: GiphyBlockAttsInterface): JSX.Element => {
  const { url, width, height, description } = value;

  return (
    <div class='my-[18px]'>
      <figure class='flex justify-center'>
        <img
          src={url}
          width={typeof width === 'number' ? width : parseInt(width)}
          height={typeof height === 'number' ? height : parseInt(height)}
          alt={description}
        />
      </figure>
    </div>
  );
});
